/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Scope_Detail5Inputs */

const en_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define what it does and exactly where it injects or interacts.`)
};

const ar_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد ما تفعله وأين تُحقن أو تتفاعل بالضبط.`)
};

const bn_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এটি কী করে এবং কোথায় ইনজেক্ট বা ইন্টারঅ্যাক্ট করে, তা নির্ধারণ করুন।`)
};

const de_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definieren Sie, was es tut und wo genau es injiziert oder interagiert.`)
};

const es_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define qué hace y exactamente dónde inyecta o interactúa.`)
};

const fr_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définissez ce qu'il fait et exactement où il injecte ou interagit.`)
};

const pt_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina o que faz e exatamente onde injeta ou interage.`)
};

const zh_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定义它的作用以及它注入或交互的确切位置。`)
};

const tr_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne yaptığını ve tam olarak nereye enjekte ettiğini veya etkileşime girdiğini tanımlayın.`)
};

const ru_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Определите, что он делает и где именно он внедряется или взаимодействует.`)
};

const pl_svc_browser_extensions_scope_detail5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdefiniuj, co robi i gdzie dokładnie wprowadza działanie lub wchodzi w interakcję.`)
};

/**
* | output |
* | --- |
* | "Define what it does and exactly where it injects or interacts." |
*
* @param {Svc_Browser_Extensions_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_scope_detail5 = /** @type {((inputs?: Svc_Browser_Extensions_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "de") return de_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "es") return es_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_scope_detail5(inputs)
	return en_svc_browser_extensions_scope_detail5(inputs)
});
export { svc_browser_extensions_scope_detail5 as "svc_browser-extensions_SCOPE_detail" }